import Dinero, { Currency } from "dinero.js";
import { Decimal } from "decimal.js";

export function sumDinero(amounts: Dinero.Dinero[], currency: Currency = "EUR") : Dinero.Dinero {
  let total = Dinero({ amount: 0, currency });
  for (const amount of amounts) {
    total = total.add(amount);
  }
  return total;
}

export function formatFrDinero(amount: Dinero.Dinero) : string {
  return amount.setLocale("fr-FR").toFormat("0.00 dollar")
}
